module.exports = __webpack_public_path__ + "img/voltar_conversa.759add22.gif";